/* eslint-disable eqeqeq */
import React from "react";
import BootstrapTable from "react-bootstrap-table-next";
import axios from "axios";
import {
  formatAccountNumber,
  formatBSBNumber,
  formatContactNameType,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import CustomTooltip from "../../components/CustomTooltip";
import {
  TableClasses,
  TableWrapClasses,
  TDClasses,
  THClasses,
  TRClasses,
} from "../../config";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { defaultBaseUrl } from "../../APIConfig/Interceptor";
import { faFileDownload } from "@fortawesome/free-solid-svg-icons";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { cn } from "../../lib/utils";
import { LawyerConditon } from "../../lib/PermissionConditions";

const ExpandPayment = ({ expandData }) => {
  const { organizationData } = useOrganization();
  const handleDownload = async (value) => {
    try {
      const response = await axios.get(`${value}`, {
        responseType: "blob",
      });
      const fileData = response.data;
      const url = window.URL.createObjectURL(new Blob([fileData]));

      var a = document.createElement("a");
      a.href = url;
      var extention = value.split(".");
      var file = value.split("/");
      a.setAttribute(
        "download",
        file[file.length - 1] || "document" + extention
      );
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (e) {}
  };

  const expandDataGenerator = (quantity) => {
    const items = [];
    for (let i = 0; i < quantity; i++) {
      items.push({
        key: expandData[i]?.id,
        payee: formatContactNameType(
          expandData[i],
          organizationData?.organizationData
        ),
        amount: expandData[i]?.amount ? (
          <b>${formatNumber(Number(expandData[i]?.amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        amount_exc: expandData[i]?.amount_exc ? (
          <b>${formatNumber(Number(expandData[i]?.amount_exc))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        tax_amount: expandData[i]?.tax_amount ? (
          <b>${formatNumber(Number(expandData[i]?.tax_amount))}</b>
        ) : (
          <b>{"$0.00"}</b>
        ),
        bsb: expandData[i]?.bsb ? formatBSBNumber(expandData[i]?.bsb) : "-",
        account_number: expandData[i]?.account_number
          ? formatAccountNumber(expandData[i]?.account_number)
          : "-",
        description: expandData[i]?.description
          ? expandData[i]?.description
          : "-",
        asset: expandData[i]?.asset?.name ? expandData[i]?.asset?.name : "-",
        sub_asset: expandData[i]?.sub_asset?.name
          ? expandData[i]?.sub_asset?.name
          : "-",
        contract: expandData[i]?.contract
          ? expandData[i]?.contract?.contract_number
          : "-",
        contact: expandData[i]?.contact
          ? formatSubcontractorName(expandData[i]?.contact)
          : "-",
        job: expandData[i]?.ts_job?.code ? expandData[i]?.ts_job?.code : "-",
        task: expandData[i]?.ts_task?.code ? expandData[i]?.ts_task?.code : "-",
        action: (
          <>
            {expandData[i]?.contract_file && (
              <CustomTooltip message={"Download"}>
                <span>
                  <FontAwesomeIcon
                    onClick={() =>
                      expandData[i]?.contract_file?.includes(defaultBaseUrl())
                        ? handleDownload(expandData[i]?.contract_file)
                        : window.open(expandData[i]?.contract_file, "_blank")
                    }
                    icon={faFileDownload}
                    size="1x"
                    data-toggle="modal"
                    data-target="#deleteAccount"
                  />
                </span>
              </CustomTooltip>
            )}
          </>
        ),
      });
    }
    return items;
  };

  const subExapndData = expandDataGenerator(expandData?.length);

  let columns = [
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "payee",
      text: "Payee",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount",
      text: "Amount (Inc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "amount_exc",
      text: "Amount (Exc)",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "tax_amount",
      text: "Tax",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "bsb",
      text: "BSB",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "account_number",
      text: "Account Number",
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "description",
      // text: "Description",
      text: (LawyerConditon(organizationData) ? "Matter Description" : "Description"),
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "asset",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "assets",
        "Asset"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "sub_asset",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "sub-assets",
        "Sub Asset"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "contract",
      text: "Contract",
    },
    {
      headerClasses: cn(
        THClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      classes: cn(
        TDClasses,
        "whitespace-normal break-words" // fixed width + wrapping
      ),
      dataField: "contact",
      text: `${getModuleNamingBySlug(
        organizationData?.organizationData,
        "contacts",
        "Customer"
      )}`,
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "job",
      text: "Job",
    },
    {
      headerClasses: THClasses,
      classes: TDClasses,
      dataField: "task",
      text: "Task",
    },
    // {
    //   headerClasses: THClasses,
    //   classes: TDClasses,
    //   dataField: "action",
    //   text: "Action",
    //   align: "center",
    //   headerAlign: "center",
    // },
  ];

  if (LawyerConditon(organizationData)) {
    columns = columns?.filter(
      (item) => item.dataField !== "job" && item.dataField !== "task"
    );
  }

  return (
    <>
      <div className="custom-table p-2">
        <div className={"table-body-class"}>
          <BootstrapTable
            keyField="key"
            remote
            data={subExapndData}
            columns={columns}
            rowClasses={TRClasses}
            noDataIndication="No Data Found"
            classes={TableClasses}
            wrapperClasses={TableWrapClasses}
          />
        </div>
      </div>
    </>
  );
};

export default ExpandPayment;
